import BaseService from './base'

export default class PartnerBankService extends BaseService {
  static resource() {
    return 'api/v1/external/partnerBanks'
  }
}
